module.exports = __webpack_public_path__ + "static/media/ScheduleDocsInstructions.109614aa.pdf";